import { ReduxAction } from "../../types";
import ClientsForm from "./ClientsForm";
import * as Nested from "../../util/Nested";

interface State {}

const initialState: State = {};

export const CLIENTS_FORM_ACTION = "posConfigTool/CLIENTS_FORM_ACTION";
export const clientsFormAction = Nested.nestedAction(CLIENTS_FORM_ACTION);

const _reducer = (state: State = initialState, { type }: ReduxAction): State => {
  switch (type) {
    default:
      return state;
  }
};

// Raw Redux Maps
export const _mapStateToProps = () => {};
export const _mapDispatchToProps = () => {};

// Nested Redux Maps
const {
  reducer: nestedReducer,
  mapStateToProps,
  mapDispatchToProps,
} = Nested.nestStates(
  {
    reducer: _reducer,
    mapStateToProps: _mapStateToProps,
    mapDispatchToProps: _mapDispatchToProps,
  },
  {
    forms: {
      clientsForm: {
        ...ClientsForm,
        actionType: CLIENTS_FORM_ACTION,
      },
    },
  },
  "clients"
);

// Nested Reducer
const reducer = (state: State, action: ReduxAction) => nestedReducer(state, action);
export { reducer, mapStateToProps, mapDispatchToProps };
